import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-alternatives-amlbot',
  imports: [MatIcon, RouterLink, RelatedPagesComponent],
  templateUrl: './amlbot.component.html',
  styleUrl: './amlbot.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlternativesAmlbotComponent {
  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/aml-check',
      anchor: "Online AML check",
      text: "The check on its own: one address screened against four AML data providers, with the disagreements kept.",
    },
    {
      link: '/aml-compliance-software',
      anchor: "AML compliance software",
      text: "The platform around the check: monitoring, alerts, team roles, investigations and the API.",
    },
  ];

  private readonly _platformId = inject(PLATFORM_ID);

  readonly createAccountHref = computed(() => {
    if (!isPlatformBrowser(this._platformId)) {
      return 'https://app.amlofficer.org/register-corporate-account';
    }

    const referralLink = localStorage.getItem('referralLink');
    const trackingLink = localStorage.getItem('trackingLink');
    const queryParams = new URLSearchParams();
    if (referralLink) {
      queryParams.set('referralLink', referralLink);
    }
    if (trackingLink) {
      queryParams.set('trackingLink', trackingLink);
    }
    const query = queryParams.toString();
    return query
      ? `https://app.amlofficer.org/register-corporate-account?${query}`
      : `https://app.amlofficer.org/register-corporate-account`;
  });
}
